import { useState } from 'react'
import Box from '@mui/material/Box'
import styled from '@emotion/styled'
import { get } from 'lodash-es'
import { GtmAgent } from 'utils/hooks/analytics'

const DEFAULT_SERVICELOGO = '/img/default_service_icon.svg'

const ItemWrapper = styled(Box)`
  ${({ theme, $hovered }) => `
    border-radius: 6px;
    display: flex;
    align-items: center;
    padding: 12px;
    cursor: pointer;
    width: 100%;

    ${theme.breakpoints.down('lg')} {
      flex-direction: column;
      padding: 0px;
      width: 100%;
    }
  `}
`

const ServiceClassificationIcon = styled.div`
  ${({ theme, $hovered, src, type }) => `
    margin: 0 8px 0 0;
    background: ${`url(${src})`} no-repeat;;
    background-size: ${type === 'serviceClassification' ? '48px' : '100%'};
    background-position: 50% 50%;
    min-width: 56px;
    min-height: 56px;
    border-radius: 28px;

    ${theme.breakpoints.down('lg')} {
      margin: 0 0 12px;
    }
  `}
`

const ItemTitle = styled(Box)`
  ${({ theme, $hovered }) => `
    font-weight: 400;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    font-size: 16px;
    color: ${$hovered ? theme.palette.primary.main : theme.palette.text.minus1};
    max-width: 100%;
    word-break: break-word;
    overflow-wrap: break-word;

    ${theme.breakpoints.down('lg')} {
      text-align: center;
      max-width: 100%;
    }
  `}
`

const GridItemImage = ({
  item,
  menuDataForGa,
  subMenuDataForGa,
  subCatalogDataForGa,
  handleClose,
  onServiceClassificationClick,
  hasSubMenu,
}) => {
  const [hovered, setHovered] = useState(false)

  let iconSrc
  if (item.type === 'serviceClassification') {
    iconSrc = get(
      item,
      'serviceClassification.entranceIcon.url',
      DEFAULT_SERVICELOGO
    )
  } else {
    iconSrc = get(item, 'icon.url', DEFAULT_SERVICELOGO)
  }

  return (
    <ItemWrapper
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      $hovered={hovered}
      onClick={() => {
        GtmAgent.directSendToGTM({
          event: 'living_action',
          living_event_name: 'headermenu_click',
          living_click_name:
            item?.type === 'serviceClassification'
              ? item?.serviceClassification?.name
              : item?.name,
          living_click_location: 'web_主選單細項',
          ...(item?.serviceClassification?._id && {
            living_click_id: item.serviceClassification._id,
          }),
          living_category1_name: menuDataForGa?.name,
          ...(menuDataForGa?._id && { living_category1_id: menuDataForGa._id }),
          ...(subMenuDataForGa?.name &&
            hasSubMenu && {
              living_category2_name: subMenuDataForGa.name,
            }),
          ...(subMenuDataForGa?._id &&
            hasSubMenu && {
              living_category2_id: subMenuDataForGa._id,
            }),
          living_category3_name: subCatalogDataForGa?.name,
          ...(subCatalogDataForGa?._id && {
            living_category3_id: subCatalogDataForGa._id,
          }),
        })

        handleClose()
        onServiceClassificationClick(item)
      }}
    >
      <ServiceClassificationIcon
        $hovered={hovered}
        src={iconSrc}
        type={item.type}
      />
      <Box>
        <ItemTitle $hovered={hovered}>
          {item.type === 'serviceClassification'
            ? item?.serviceClassification?.name
            : item?.name}
        </ItemTitle>
      </Box>
    </ItemWrapper>
  )
}

export default GridItemImage
